import PropTypes from 'prop-types'
import React from 'react'

import loadable from '@loadable/component'

const GalleryMobile = loadable(() => import('./Gallery/Mobile'))
const GalleryDesktop = loadable(() => import('./Gallery/Desktop'))

const PageBuilderGallery = ({ block, raw, index, booking, priority = false }, props) => {
  return (
    <section>
      <div className="md:hidden">
        <GalleryMobile
          bgImg={block.bgImg}
          gallery={block.gallery}
          heading={block.heading}
          booking={booking}
          priority={priority}
        />
      </div>
      <div className="hidden md:block">
        <GalleryDesktop
          bgImg={block.bgImg}
          gallery={block.gallery}
          heading={block.heading}
          booking={booking}
          priority={priority}
        />
      </div>
    </section>
  )
}

PageBuilderGallery.propTypes = {
  block: PropTypes.object,
  raw: PropTypes.object,
  index: PropTypes.number,
}

PageBuilderGallery.defaultProps = {
  block: {},
  raw: {},
  index: 0,
}

export default PageBuilderGallery
